import React, {useState, useEffect,} from 'react';
import { BrowserRouter, Routes, Route, useLocation} from 'react-router-dom';
import ReactGA from 'react-ga4';
import NotFound from 'page/NotFound';
import Header from 'component/Header'; // 헤더 컴포넌트 import

import {common} from './routers/Common'

import './resource/css/reset.css';
import './resource/css/common.css';
import './resource/css/micromodal.css';
import { Footer } from 'component/Footer';

function App() {
  const fn_goTop = ()=>{
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
  }
  const currUrl = window.location.href

  // Google Analytics 초기화
  ReactGA.initialize('G-0EY0GK93F6'); // 여기서 'G-XXXXXXXXXX'는 실제 추적 ID로 대체하세요

  const fn_addRoute = (routeList, addList)=>{

    if(addList!=null && addList.length>0){
      addList.forEach((ob)=>{
        routeList.push(ob);
      })
    }
  }
  
  let routeList = new Array();
  
  fn_addRoute(routeList, common);


  return (
    <BrowserRouter>
      <Header /> {/* 헤더 컴포넌트 추가 */}
      <div className="contents">
        <Routes>
          {
            routeList.map((ob, i)=>{
              return (
                <Route key={i} path={ob.path} element={ob.element}></Route>
              )
            })
          }
          <Route path={"*"} element={<NotFound/>}></Route>
        </Routes>
      </div>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
